<script>
import Confirmation from '@/components/widgets/modals/Confirmation'

export default {
  components: { Confirmation },
  props: {
    title: {
      type: String,
      default: 'Set Mode',
    },
    modal: {
      type: Boolean,
      default: false,
    },
    modes: {
      type: Function,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: 'Yakin ingin mengatur Mode?',
    },
    region: {
      type: String,
      default: 'SG'
    },
  },
  data() {
    return {
      modalConfirm: false,
      formValues: {},
      validation: false,
      debounceTimer: null,
    }
  },
  watch: {
    'formValues.N'(newVal) {
      if (!newVal) return
      this.getDefaultValue(newVal)
    },
  },
  computed: {
    showModal: {
      get() {
        return this.modal
      },
      set(newVal) {
        this.$emit('update:modal', newVal)
      },
    },
    loading: {
      get() {
        return this.isLoading
      },
      set(newVal) {
        this.$emit('update:isLoading', newVal)
      },
    },
    fields() {
      if (!this.formValues.N) return []
      const modes = this.modes()
      const fields = modes.data.find((e) => e.N === this.formValues.N)?.fields
      return fields
    },
    generateString() {
      if (!this.formValues.N) return
      const modes = this.modes()
      const formula = modes.data.find((e) => e.N === this.formValues.N)?.formula
      const matchingKeyFormulas = Object.keys(this.formValues).filter((key) =>
        formula.body.includes(key)
      )
      const body = matchingKeyFormulas.map((key) => this.formValues[key]).join(',')
      return `${formula.prefix}${body}${formula.suffix}`
    },
  },
  methods: {
    handleSubmit(bvModalEvent) {
      bvModalEvent.preventDefault()
      if (this.validation.hasErrors) return
      this.modalConfirm = true
    },
    afterConfirm() {
      const payload = {
        command: this.generateString,
      }
      const modes = this.modes()
      const powermode = modes.data.find((e) => e.N === this.formValues.N)?.powermode
      this.$emit('beforeSubmit', { payload, overwrite: false, powermode: powermode })
    },
    handleFailedValidation(validation) {
      let self = this
      self.validation = validation
      self.debounceTimer = setTimeout(() => {
        if (self.validation.hasErrors) {
          self.$toast.error('Terdapat kesalahan format pada input anda')
          return true
        }
        return false
      }, 1000)
    },
    getDefaultValue(mode) {
      let self = this
      self.debounceTimer = setTimeout(() => {
        const fields = self.modes().data?.find((e) => e.N === mode).fields
        Object.keys(fields)?.forEach((key) => {
          self.$refs[`${key}-ref`][0].context.model = fields[key].default
        })
      }, 10)
    },
  },
}
</script>
<template>
  <div>
    <b-modal
      v-model="showModal"
      class="mc-modal"
      id="modal-form"
      :title="title"
      size="md"
      centered
      :hide-header-close="loading"
      no-close-on-backdrop
    >
      <div class="card-body mc-modal__filter p-2">
        <FormulateForm 
          v-model="formValues" 
          ref="modeFormRef" 
          @submit.stop.prevent="handleSubmit"
          @validation="handleFailedValidation">
          <FormulateInput
            type="select-resourceful"
            name="N"
            label="Mode"
            placeholder="Pilih Mode"
            :optionsGetter="modes"
            :optionLabelFn="
              ({ item }) => {
                return item.description
              }
            "
            :allow-empty="false"
            trackBy="N"
          />
          <div v-for="(field, idx) of fields" :key="idx">
            <div v-if="field.tooltip !== undefined">
              <i :id="`tool-table-layout-${idx}`" class="icon-outline_info float-end pt-2"></i>
              <b-tooltip
                :target="`tool-table-layout-${idx}`"
                triggers="hover"
                placement="lefttop"
                class="text-start"
              >
                {{ field.tooltip }}
              </b-tooltip>
            </div>
            <FormulateInput
              :type="field.type ?? 'text'"
              :name="idx"
              :label="field.description"
              :placeholder="field.placeholder"
              :optionsGetter="modes"
              :optionLabelFn="
              ({ item }) => {
                return item.description
              }
              "
              datepickerType="time"
              format="HH:mm"
              value-type="HH:mm"
              :validation="field.validation"
              validation-behavior="live"
              error-behavior="live"
              :ref="`${idx}-ref`"
              :append="field.uom"
              class="mt-2"
            />
          </div>
        </FormulateForm>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer">
          <b-col cols="12" class="mc-modal__filter-footer-btn">
            <b-button variant="outline-primary" @click="cancel()" :disabled="loading" class="me-3">
              Batal
            </b-button>
            <b-button @click="handleSubmit" variant="primary" :disabled="loading">
              <b-spinner v-if="loading" small type="grow"></b-spinner>
              {{ loading ? 'Loading...' : 'Simpan' }}
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <confirmation
      v-if="modalConfirm"
      :modal.sync="modalConfirm"
      :message="message"
      @confirmed="afterConfirm"
    />
  </div>
</template>
